import { type ProductForHotelFilters } from '@ve/components/hotel/filters/common/store/types';
import { OperatorId } from '@entities/operator';
import { type ITourProduct } from '@entities/tourProduct';

export const BONUS_MILES_OPERATORS = new Set(OperatorId.Travelata);

export const BONUS_MILES_TEXT = 'Начисление миль'

export const filterByBonusMiles = (tourProduct: ITourProduct | ProductForHotelFilters): boolean => !!tourProduct?.operator && BONUS_MILES_OPERATORS.has(tourProduct.operator?.id);